import { Trans, useTranslation } from "react-i18next";
import CodeBlock from "../components/CodeBlock";

export default function NowPlayingCard() {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t("nowPlayingCard.title")}</h1>
      <p>
        <Trans i18nKey="nowPlayingCard.intro" components={[<a key="0" href="/docs/kira-arts/playground" />]} />
      </p>

      <CodeBlock title="with an adapter">{`import { nowPlayingImage, fromMoonlinkTrack } from "kira-arts";

const track = fromMoonlinkTrack(player.current);

const buffer = await nowPlayingImage(track, {
  guildId,
  useRoleColor: true,
});`}</CodeBlock>

      <p>
        <Trans i18nKey="nowPlayingCard.adaptersIntro" components={[<code key="0" />]} />
      </p>

      <CodeBlock title="available adapters">{`fromMoonlinkTrack(track)
fromLavalinkTrack(track)
fromDiscordPlayerTrack(track)
fromDistubeTrack(song)`}</CodeBlock>

      <p>
        <Trans
          i18nKey="nowPlayingCard.manualNote"
          components={[
            <code key="0" />,
            <code key="1" />,
            <code key="2" />,
            <code key="3" />,
            <code key="4" />,
            <code key="5" />,
          ]}
        />
      </p>
    </article>
  );
}
